import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  ElearningListingHero,
  ElearningAllCourse,
  ElearningListingHowItWorks,
} from "@modules/elearning/listing";

import { FAQSection } from "@modules/study/common/sections";

import faqData from "@_fakeData/faq.json";

const Elearning = () => {
  return (
    <LayoutMain
      footer_with_evaluation
      title="eLearning Listing Page"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/listing-page`}
    >
      <ElearningListingHero />
      <ElearningAllCourse />
      <ElearningListingHowItWorks />
      <FAQSection faqData={faqData} title="Frequently Asked Questions" />
    </LayoutMain>
  );
};

export default Elearning;
